import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { LikeList } from '../like-list/like-list';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-manage-saved',
  imports: [
    CommonModule,
    MatCardModule,
    LikeList
  ],
  templateUrl: './manage-saved.html',
  styleUrl: './manage-saved.scss',
})
export class ManageSavedComponent implements OnInit {
  platformId = inject(PLATFORM_ID);
  userTotalLikes = 0;
  private gtm = inject(GtmService);
  private seo = inject(SeoService);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/profile/manage-saved',
        page_title: 'Manage Saved | Horizinns'
      });
    }
    
    this.seo.updateMetaTags(
      'Manage Saved', 
      'Manage saved properties on Horizinns',
      undefined,
      `${environment.appUrl}/profile/manage-saved`
    );
  }
  
  constructor() {}

  onTotalLikesChange(count: number) {
    this.userTotalLikes = count;
  } 
}
